import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';
const VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/FourColumnCardsMobileVector.svg';

const FourColumnCardsMobileComponent = ({ data }) => {
  const { title, description, footer, cards } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        maxWidth: '100vw',
        borderRadius: '48px',
        padding: '32px 0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        gap: '16px',
      }}
    >
      {/* Title */}
      <ScrollFadeWrapper variant="text">
        <Typography
          component={data.component || 'h2'}
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '2rem',
            lineHeight: '2.25rem',
            letterSpacing: '-0.03em',
            color: '#162F3B',
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
      </ScrollFadeWrapper>

      {/* Description */}
      <ScrollFadeWrapper variant="text" delay={0.2}>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1.25rem',
            lineHeight: '1.5rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            maxWidth: '343px',
            mb: '22px',
          }}
        >
          {description}
        </Typography>
      </ScrollFadeWrapper>

      {/* Cards */}
      {cards.map((card, index) => (
        <ScrollFadeWrapper key={index} delay={0.4 + index * 0.1}>
          <Box
            sx={{
              width: '100%',
              maxWidth: '100vw',
              backgroundColor: '#FFFFFF',
              borderRadius: '32px',
              padding: '32px',
              boxShadow: '0px 6px 16px #162F3B1F, 0px 1px 2px #A2ACB11F',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '24px',
            }}
          >
            {/* Vector + Icon */}
            <Box sx={{ position: 'relative', width: '80px', height: '80px' }}>
              <Image
                width={80}
                height={80}
                src={VECTOR_URL}
                alt="Card background vector graphic"
                sx={{ width: '100%', height: '100%' }}
              />

              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <img
                  width={42}
                  height={42}
                  src={card.icon}
                  alt={card.imgAltTag || card.title}
                  title={card.imageAltTitle || card.title}
                  style={{ width: '42px', height: '42px' }}
                />
              </Box>
            </Box>

            {/* Title */}
            <Typography
              component={card.component || 'h3'}
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '1.25rem',
                lineHeight: '1.5rem',
                color: '#162F3B',
                textAlign: 'center',
              }}
            >
              {card.title}
            </Typography>

            {/* Body */}
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                color: '#162F3B',
                textAlign: 'left',
                letterSpacing: '-0.002em',
              }}
            >
              {card.body}
            </Typography>
            {card.linkText && (
              <Link
                href={card.link}
                target="_blank"
                underline="none"
                sx={{
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  lineHeight: '1.25rem',
                  color: '#A2ACB1',
                  mt: '24px',
                  '&:hover': {
                    color: '#9EA900',
                    textDecoration: 'underline',
                  },
                }}
              >
                {card.linkText}
              </Link>
            )}
          </Box>
        </ScrollFadeWrapper>
      ))}

      {/* Footer */}
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: '1rem',
          lineHeight: '1.5rem',
          letterSpacing: '-0.002em',
          textAlign: 'center',
          color: '#162F3B',
          maxWidth: '343px',
          mt: '26px',
        }}
      >
        {footer}
      </Typography>
    </ScrollFadeSection>
  );
};

export default FourColumnCardsMobileComponent;
